import Validators from "Common/Validators";
const requiredMessage = "This field is required";
const show =true;
export default {
  socio_demographic_detail: {
    number_of_years: [Validators.checkDecimalPrescription],
    family_size: [Validators.checkOnlyNumber],
    informant_name: [Validators.validateIsAlphabetsName],
    referring_clinician_name: [() => Validators.validateFirstName(false)],
    pin_zip_code: [Validators.checkZipCode],
    // state:[ Validators.checkAlphaNumericSpecialCharacters],
    // country:[Validators.checkAlphaNumericSpecialCharacters],
    // mobile_number:[Validators.mobileNumberTenDigit],
    alternate_mobile_number: [Validators.mobileNumberTenDigit],
    alternate_email_id: [Validators.checkEmail],
    // email_id:[ Validators.checkEmail],
    // weight:[Validators.checkDecimal, Validators.checkWeight],
    // height:[Validators.checkDecimal, Validators.checkHeight],
    // city_town_village:[Validators.checkAlphaNumericSpecialCharacters],
    // area:[ Validators.checkAlphaNumericSpecialCharacters],
    // address:[ Validators.checkAlphaNumericSpecialCharacters],
  },
  sexual_health: {
    sexual_problem_comments: [Validators.checkAlphaNumericSpecialCharacters],
    doctors_comment: [Validators.checkAlphaNumericSpecialCharacters],
  },
  occupational_detail: {
    designation: [Validators.checkAlphaNumericSpecialCharacters],
    reason: [Validators.checkAlphaNumericSpecialCharacters],
    number_of_job_in_last_2_years: [
      Validators.checkOnlyNumber,
      Validators.checkMaxLimits,
    ],
    comments: [Validators.checkAlphaNumericSpecialCharacters],
    doctors_comment: [Validators.checkAlphaNumericSpecialCharacters],
  },
  past_hospitalization_history: {
    comments: [Validators.checkAlphaNumericSpecialCharacters],
    doctors_comment: [Validators.checkAlphaNumericSpecialCharacters],
  },
  educational_detail: {
    number_of_close_friends: [
      Validators.checkOnlyNumberForEducational,
      Validators.validateIsNumber,
    ],
    reason: [Validators.checkAlphaNumericSpecialCharacters],
  },
  physical_illness_in_the_family: {
    doctors_comment: [Validators.checkAlphaNumericSpecialCharacters],
  },
  physical_health_complaints: {
    comments: [Validators.checkAlphaNumericSpecialCharacters],

    medicine: [
      {
        required: true,
        message: requiredMessage,
      },
      Validators.checkAlphaNumericSpecialCharacters,
    ],
    dosage: [
      {
        required: true,
        message: requiredMessage,
      },
      Validators.checkDecimal,
      Validators.checkMaxLimits,
    ],
    frequency: [
      {
        required: true,
        message: requiredMessage,
      },
      Validators.checkDosageFrequency,
      Validators.checkStringLength,
    ],
    doctors_comment: [Validators.checkAlphaNumericSpecialCharacters],
    starting_year: [
      {
        required: true,
        message: requiredMessage,
      },
    ],
  },
  presenting_complaints: {
    comments: [Validators.checkAlphaNumericSpecialCharacters],
    home: [Validators.checkAlphaNumericSpecialCharacters],
    school: [Validators.checkAlphaNumericSpecialCharacters],
    others: [Validators.checkAlphaNumericSpecialCharacters],
    doctors_comment: [Validators.checkAlphaNumericSpecialCharacters],
    concern: [Validators.checkAlphaNumericSpecialCharacters],
    care_team_concern: [Validators.checkAlphaNumericSpecialCharacters],
    duration_period: [Validators.checkDecimalPrescription],
    duration_period_1: [Validators.documentNumberDuration],
    reason_for_relapse: [
      Validators.checkAlphaNumericSpecialCharacters,
      Validators.checkStringLength,
    ],
  },
  mensuration_detail: {
    if_irregular: [Validators.checkAlphaNumericSpecialCharacters],
    medication_value: [
      {
        required: show,
        message: requiredMessage,
      },
      Validators.checkAlphaNumericSpecialCharacters,
    ],
    duration_period: [
      {
        required: show,
        message: requiredMessage,
      },
      Validators.checkDecimal,
      Validators.checkMaxLimits,
    ],
    doctors_comment: [Validators.checkAlphaNumericSpecialCharacters],
  },
};
